import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Modal from '@mui/joy/Modal'
import ModalDialog from '@mui/joy/ModalDialog'
import ModalClose from '@mui/joy/ModalClose'
import Sheet from '@mui/joy/Sheet'
import Typography from '@mui/joy/Typography'
import AspectRatio from '@mui/joy/AspectRatio'

const ModalBody = ({ template, isSelected, onToggle }) => {
    const unselectBtn = (
        <Button
            size="lg"
            color="danger"
            variant="outlined"
            onClick={() => onToggle(template)}
            disabled={false}
        >
            Unselect
        </Button>
    )

    const selectBtn = (
        <Button
            size="lg"
            color="primary"
            onClick={() => onToggle(template)}
            disabled={false}
        >
            Select
        </Button>
    )

    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography level="title-lg">{template.title}</Typography>
                <Sheet variant="soft" sx={{ display: 'flex', flex: 1 }}>
                    <AspectRatio ratio="1/1" sx={{ width: 400, p: 4 }}>
                        <img src={template.preview_image} />
                    </AspectRatio>
                </Sheet>
                <Box sx={{ display: 'flex', flex: 1, alignSelf: 'center' }}>
                    {isSelected ? unselectBtn : selectBtn}
                </Box>
            </Box>
        </Box>
    )
}

export const TemplateModal = ({
    isOpen,
    template,
    isSelected,
    onClose,
    onToggle,
}) => {
    return (
        <Modal open={isOpen} onClose={onClose} size="lg" variant="solid">
            <ModalDialog>
                <Box sx={{ mb: 2 }}>
                    <ModalClose />
                </Box>
                <ModalBody
                    template={template}
                    isSelected={isSelected}
                    onToggle={onToggle}
                />
            </ModalDialog>
        </Modal>
    )
}
